<template>
  <div class="row-box">
    <WrapperField
      v-for="(value, key) in data"
      :key="value + key"
      :data="
        createDataField({
          fieldName: key,
          fieldValue: value,
          fieldGroup: FieldGroup.CORRECT_TRANSLATION_DETAILS,
        })
      "
    />

    <WrapperField
      v-for="(value, key, index) in data.translatedDocument"
      :key="value + key + index"
      :data="
        createDataField({
          fieldName: key,
          fieldValue: value,
          fieldGroup: FieldGroup.TRANSLATED_DOCUMENT,
        })
      "
    />
  </div>
</template>

<script>
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import { createDataField, FieldGroup } from '@/utils/fullStatementView';

export default {
  name: 'Step2',
  props: ['data'],
  components: {
    WrapperField,
  },
  data: () => ({
    FieldGroup,
    createDataField,
  }),
};
</script>
